import { render, staticRenderFns } from "./GoodTableColumnSearch.vue?vue&type=template&id=0b92568e&"
import script from "./GoodTableColumnSearch.vue?vue&type=script&lang=js&"
export * from "./GoodTableColumnSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports